import React, { useState } from 'react';
import { DEFAULT_PLACEHOLDER } from '../../utils';
import styles from './index.module.scss';

const reg = /.+?\:\/\/.+?(\/.+?)(?:#|\?|$)/;
export const imageKitBaseURL = 'https://ik.imagekit.io/ykmmrc3nwl';

const ImageWrapper = ({ src=DEFAULT_PLACEHOLDER, alt = '', bl, width, height, className, clickForFullScreen = false }: any) => {
  const imageName = getImageName(src);
  const imageUrlQuery = getImageUrlQuery({ height, width, bl });
  const imageSrc = `${imageKitBaseURL}/${imageName}${imageUrlQuery}`;

  const [isImageOpen, setIsImageOpen] = useState(false);

  const openFullScreenImage = () => {
    if (!clickForFullScreen) return;
    setIsImageOpen(true);
  };

  const closeFullScreenImage = () => {
    setIsImageOpen(false);
  };

  const onClickFullScreenImage = (e) => {
    e.stopPropagation();
  };

  if (isImageOpen) {
    return (
      <div
        onClick={closeFullScreenImage}
        className={`${styles['lightbox']} ${styles['show']} relative`}
      >
        <img
          onClick={onClickFullScreenImage}
          className={styles['show_image']}
          src={imageSrc}
        />
        <span
          className={styles['close-icon']}
          onClick={closeFullScreenImage}
        >
          <i className="fa fa-times-circle"></i>
        </span>
      </div>
    );
  } else {
    return (
      <img
        className={className}
        alt={alt}
        onClick={openFullScreenImage}
        src={imageSrc}
        style={{
          transition: 'opacity .15s linear',
        }}
      />
    );
  }
};

function getImageName (url): string {
  const pathnames = (((reg.exec(url) || [])[1]) || '').split('/');
  return pathnames[pathnames.length - 1];
}

function getImageUrlQuery (params): string {
  const { bl, height, width } = params;
  let query = '';
  if (bl) {
    query = `tr=bl-${bl},`;
  }
  if (height) {
    query = `height=${height},`;
  }
  if (width) {
    query = `width=${width},`;
  }
  return query ? `?${query}` : query;
}

export default React.memo(ImageWrapper);
